'use client'
import clsx from 'clsx'

import { Translation } from '@/types/Content.types'

import HeaderProvider from './context/HeaderProvider'

import HeaderMain from './Header'
import PreHeader from './PreHeader'
import styles from './Header.module.scss'

const Header = ({
  isHomepage,
  translations,
  minified,
}: {
  isHomepage?: boolean
  translations?: Translation[]
  minified?: boolean
}) => {
  return (
    <HeaderProvider
      isHomepage={isHomepage}
      translations={translations}
    >
      <header className={clsx(styles.headerWrapper)}>
        <PreHeader />
        <HeaderMain minified={minified} />
      </header>
    </HeaderProvider>
  )
}

export default Header
